import { useEffect, useState } from 'react';

import { getStripeFeature } from '@/pages/AccountSettings/api';

export function usePmsApiEnabled() {
  const [pmsApiEnabled, setPmsApiEnabled] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function load() {
      try {
        const feat = (await getStripeFeature()) ?? { features: [] };
        setPmsApiEnabled(feat.features.includes('PMS_API'));
      } finally {
        setLoading(false);
      }
    }
    load();
  }, []);

  return { pmsApiEnabled, loading };
}
